import type { Currency, Promotion, PromotionInput } from '@weft/types';
import React from 'react';
import { CreatePlanSection } from '../CreatePlanSection';
import { PromotionCharge } from './PromotionCharge';

export type PromotionsProps = {
  editable?: boolean;
  promotions: Promotion[] | PromotionInput[];
  currency: Currency;
  showTitle?: boolean;
};

export const PromotionCharges: React.FC<PromotionsProps> = ({
  editable = false,
  promotions,
  currency,
  showTitle = true,
}) => {
  return (
    <CreatePlanSection
      title={showTitle ? 'Promotions' : undefined}
      hideCreateAnother
    >
      <div className="space-y-11">
        {promotions.map((promotion, promotionIndex) => (
          <PromotionCharge
            key={promotionIndex}
            promotion={promotion}
            promotionIndex={promotionIndex}
            editable={editable}
            currency={currency}
          />
        ))}
      </div>
    </CreatePlanSection>
  );
};